export default "__VITE_ASSET__1ab3e8ee__"